import { api } from "./api";
import { ISalaryRequest, SalaryRequestStatus } from "../types/salaryRequest.type";

export const salaryRequestApi = {
  // Создание запроса на увеличение зарплаты
  createSalaryRequest: async (data: {
    notes?: string;
  }) => {
    const response = await api.post("/salary-request", data);
    return response.data;
  },

  // Получение всех запросов
  getSalaryRequests: async (params?: {
    page?: number;
    limit?: number;
    status?: SalaryRequestStatus;
    month?: string;
    year?: number;
  }) => {
    const response = await api.get("/salary-request", { params });
    return response.data;
  },

  // Получение одного запроса по ID
  getSalaryRequestById: async (id: string) => {
    const response = await api.get(`/salary-request/${id}`);
    return response.data;
  },

  // Одобрение запроса
  approveSalaryRequest: async (id: string, data?: { notes?: string }) => {
    const response = await api.put(`/salary-request/${id}/approve`, data);
    return response.data;
  },

  // Отклонение запроса
  rejectSalaryRequest: async (id: string, data: {
    rejectionReason: string;
    notes?: string;
  }) => {
    const response = await api.put(`/salary-request/${id}/reject`, data);
    return response.data;
  },

  // Обновление одного элемента запроса
  updateSalaryRequestItem: async (id: string, itemIndex: number, data: {
    requestedIncrease: number;
    reason?: string;
  }) => {
    const response = await api.put(`/salary-request/${id}/items/${itemIndex}`, data);
    return response.data;
  },

  // Обновление элементов запроса
  updateSalaryRequestItems: async (id: string, data: {
    items: any[];
  }) => {
    const response = await api.put(`/salary-request/${id}/items`, data);
    return response.data;
  },

  // Удаление запроса
  deleteSalaryRequest: async (id: string) => {
    const response = await api.delete(`/salary-request/${id}`);
    return response.data;
  },
}; 